import { useState } from "react";
import "../css/adai.css";
import { PageHeader, Tabs, Spinner } from "../../shared/ui";
import AdaiForm from "../components/AdaiForm.jsx";
import ResultDisplay from "../components/ResultDisplay.jsx";
import HistoryTab from "../components/HistoryTab.jsx";

const TABS = [
  { key: "generate", label: "Generate" },
  { key: "history", label: "History" },
];

const AdaiPage = () => {
  const [result, setResult] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [apiError, setApiError] = useState("");
  const [activeTab, setActiveTab] = useState("generate");

  const handleGenerationStart = () => {
    setIsGenerating(true);
    setResult(null);
  };

  const handleGenerationEnd = (hasError) => {
    setIsGenerating(false);
    if (hasError) setResult(null);
  };

  return (
    <div>
      <PageHeader
        title="ADAI (Advanced Documentation AI)"
        subtitle="Generate release notes from your selected Version Control Platform's code and Project Lifecycle Platform's work items."
      />

      <Tabs
        tabs={TABS}
        active={activeTab}
        onChange={setActiveTab}
        className="mb-5"
      />

      {activeTab === "generate" && (
        <>
          <AdaiForm
            onResult={setResult}
            onGenerationStart={handleGenerationStart}
            onGenerationEnd={handleGenerationEnd}
            apiError={apiError}
            setApiError={setApiError}
          />
          {isGenerating && !result && (
            <div className="flex flex-col items-center justify-center gap-3 py-16">
              <Spinner />
              <p className="text-sm text-muted">
                Fetching work items and code diffs, then building your release documentation…
              </p>
            </div>
          )}
          {result && <ResultDisplay result={result} />}
        </>
      )}

      {activeTab === "history" && (
        <HistoryTab onNewGeneration={() => setActiveTab("generate")} />
      )}
    </div>
  );
};

export default AdaiPage;
